import {LocationHours, DealSaverForm, LeadScoreForm} from './location_settings_components'
import { confirmPlus } from '../common/custom_confirm';
import { LocationDocumentation } from './location_documentation';
import { TenDLCBrandModal } from './ten_dlc_brand';
import {DataBinder} from 'utils/data_binder'
import {CallTypeKeywordEditor} from './call_type_keywords/keyword_editor'


/**
    <advanced-settings
      current_user_is_account_admin=<%= current_user.is_account_admin? %>
    >
    </advanced-settings>  

 */
export class AdvancedSettings extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    this.current_user_is_admin = this.getAttribute('current_user_is_admin')
    this.current_user_is_admin = (this.current_user_is_admin === "true") ? true : false
    this.current_user_is_account_admin = this.getAttribute('current_user_is_account_admin')
    this.current_user_is_account_admin = (this.current_user_is_account_admin === "true") ? true : false
    // often an admin is also an account admin, but here we want to override this so an admin
    // can always see the queue info.
    if (this.current_user_is_admin) {
      this.current_user_is_account_admin = false
    }
    
    this.domain_id = document.querySelector("#object_id").value;
    let data_binder = new DataBinder(`/admin/domains/${this.domain_id}.json`, true);
    await data_binder.fetchData();
    let json = data_binder.data;
    this.innerHTML = 
      `
      <div>
        <div class="panel-default nav">
          <ul class="nav nav-secondary nav2-subtabs page-content-wrap" role="tablist" id='advanced-settings-tabs' style="margin-top: 0px">
            <li class="active"><a class="advanced-settings-tab nav-link active" href="message-center-settings">Message Center</a></li>
            <li><a class="advanced-settings-tab nav-link" href="campaign-notifications">Campaign Notifications</a></li>
            <li><a class="advanced-settings-tab nav-link" href="dealsaver-setup">Call Processing</a></li>
            <li><a class="advanced-settings-tab nav-link" href="company-integrations">Company Integrations</a></li>
            <li><a class="advanced-settings-tab nav-link" href="callshield-settings">CallShield</a></li>
            
            <!-- commenting out until we know if we want this
            <li><a class="advanced-settings-tab nav-link" href="call-type-keyword-editor">Call Type Keywords</a></li>
            -->
          </ul>
        </div>
        <div id="advanced-settings-content">

        </div>
      </div>
      `;

    let message_center = new MessageCenterSettings(this.domain_id);
    this.querySelector('#advanced-settings-content').appendChild(message_center);
    let campaign_notifications = new CampaignNotifications(json, this.domain_id);
    campaign_notifications.classList.add('hidden');
    this.querySelector('#advanced-settings-content').appendChild(campaign_notifications);
    let dealsaver_setup = new DealSaverSetup(json, this.domain_id, this.current_user_is_account_admin);
    dealsaver_setup.classList.add('hidden');
    this.querySelector('#advanced-settings-content').appendChild(dealsaver_setup);
    let company_integrations = new CompanyIntegrations(json, this.domain_id);
    company_integrations.classList.add('hidden');
    this.querySelector('#advanced-settings-content').appendChild(company_integrations);
    let callshield_settings = new CallshieldSettings(json, this.domain_id);
    callshield_settings.classList.add('hidden');
    this.querySelector('#advanced-settings-content').appendChild(callshield_settings);

    let callTypeKeywordSettings = new CallTypeKeywordEditor(json, this.domain_id);
    callTypeKeywordSettings.classList.add('hidden');
    this.querySelector('#advanced-settings-content').appendChild(callTypeKeywordSettings);

    this.querySelectorAll('.advanced-settings-tab').forEach(elem => {
      elem.addEventListener('click', function(e) {
        this.tabActive(e);
      }.bind(this));
    });
  }
  tabActive(e) {
    e.preventDefault()
    this.querySelectorAll('.active').forEach(elem => {
      elem.classList.remove('active');
    })
    e.target.closest('li').classList.add('active');
    this.querySelector('#advanced-settings-content').children.forEach(elem => {
      elem.hide()
    })
    document.querySelector(e.target.getAttribute('href')).show();
  }
}

customElements.define('advanced-settings', AdvancedSettings)

class MessageCenterSettings extends HTMLElement {
  constructor(domain_id) {
    super();
    this.domain_id = domain_id;
    this.deletedHours = [];
  }

  async connectedCallback() {
    this.data_binder = new DataBinder(`/admin/domains/${this.domain_id}.json`, true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }

  requestUpdate(data){
    this.data = data;
    let recipients = this.data.site.chat_notification_recipients ? this.data.site.chat_notification_recipients.split(',').join(', ') : '';
    this.innerHTML = 
      `
      <div class="location-settings-main col-md-12">
        <h3>Message Center</h3>
        <p></p>
      </div>
      <!--div class="row location-settings-main col-md-12 col-lg-8">
        <div class="alert alert-info alert-dismissible show col-sm-12" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          To set up for outbound texting, start by enabling your 10DLC.
          <a href="/admin/groups/manager" class="btn btn-primary">Go to 10DLC <span class="fa-solid fa-chevron-right"></span></a>
        </div>
      </div-->
      ${this.data.site.tnid_brand == null ? `
      <div class="row location-settings-main col-md-12 col-lg-8">
        <div class="alert alert-info alert-dismissible show col-sm-12" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          Register your 10DLC brand to set up for outbound texting.
          <button class="btn btn-primary" id="go-to-ten-dlc-button" style="margin-left: 8px">Register Brand <span class="fa-solid fa-chevron-right"></span></button>
        </div>
      </div>
      ` : `` }
      <div id="message-center-settings-main" class="row location-settings-main col-md-12 col-lg-8">
        <div class="errors"></div>
        <div class="col-sm-12 location-site-attributes no-gutters">
          <label>Company Profile</label>
          <textarea id="location_site_attributes_company_info"></textarea>
        </div>
        <div class="col-sm-12 location-site-attributes no-gutters">
          <label>Qualifying Lead Details</label>
          <textarea id="location_site_attributes_qualifying_leads"></textarea>
        </div>
        
        <div class="col-sm-12 location-hours-main no-gutters location-site-attributes">
          <div class="col-sm-6 no-gutters location-site-attributes">
            <label>Set Location Hours</label>
            <br>
            <span>Configure the standard hours of operation for this location</span>
          </div>

          <div class="col-sm-6 pull-right no-gutters">
            <button class="btn btn-primary pull-right" id="location-hours-button">Add Hours</button>
          </div>

          
          <div id="location-hours-container" class="col-sm-12 no-gutters">
          
          </div>

        </div>

        <div class="col-sm-12 no-gutters location-site-attributes">
          <div class="col-sm-6 no-gutters location-site-attributes">
            <label>10DLC Brand</label>
            <br>
            <span>Provide location info for carrier vetting for 10DLC.</span>
          </div>
          <div class="col-sm-6 pull-left no-gutters" id="ten-dlc-brand-container">  
          </div>
        </div>

        <div class="col-sm-12 no-gutters">
          <div class="col-sm-7 no-gutters location-settings-switch-div location-site-attributes">
            <div class="col-sm-6 no-gutters">
              <label>New Lead Email Notification</label>
            </div>
            <label class="col-sm-6 no-gutters switch">
              <input type="checkbox" class="form-control switch" id="NLE-notifications" ${this.data.site.chat_notification ? 'checked' : ''}>
              <span data-cy="NLE-notifications-switch"></span>
            </label>
          </div>

          <div class="col-sm-7 no-gutters">
            <label>New Lead Email Notification Recipients</label>
            <textarea class="form-control NLE-recipients" placeholder="Please separate email addresses by using a comma">${recipients}</textarea>
          </div>
        </div>


        <!--div class="col-sm-12 no-gutters">
          <h3>Notification Preferences</h3>
          <p>Select notifications and send the notifications as text messages to contact phone numbers of your choice</p>
        </div>
        <div class="col-sm-6 no-gutters location-settings-switch-div">
          <h4>When no agents are online send notifications</h4>
          <label class="switch">
            <input type="checkbox" class="form-control switch" id="MC-offline-notifications">
            <span data-cy="MC-offline-notifications-switch"></span>
          </label>
        </div>
        <div class="col-sm-7 no-gutters hidden" id="text-notification-recipients">
          <h4>Text Notification Recipients</h4>
          <label>Phone Number</label>
          <br>
          <div class="col-sm-7 no-gutters" id="text-notification-recipients-container">

          </div>
        </div-->

        <div class="col-md-12 location-settings-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-message-center-settings">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-hidden location-settings-main">
        ${LocationDocumentation.message_center}
      </div>
      `;

      this.querySelector('#location-hours-button').addEventListener('click', function(e) {
        e.preventDefault();
        let hours = new LocationHours;
        this.querySelector('#location-hours-container').appendChild(hours);
        this.buttonVisibility();
      }.bind(this))

      if(this.querySelector('#go-to-ten-dlc-button') != undefined) {
        this.querySelector('#go-to-ten-dlc-button').addEventListener('click', function(e) {
          e.preventDefault();
          $("#10DLCBrandModal").modal('show');
        }.bind(this))
      }

      // this.querySelector('[data-cy="MC-offline-notifications-switch"]').addEventListener('click', function() {
      //   this.toggleTNR();
      // }.bind(this))

      this.data.site.sites_chat_hours.forEach((hours) => {
        let location_hours = new LocationHours(hours);
        this.querySelector('#location-hours-container').appendChild(location_hours);
      })   

      $(document).ready(function() {
        $('#location_site_attributes_company_info, #location_site_attributes_qualifying_leads').summernote({
            tabsize: 2,
            height: 120,
            toolbar: [
              ['style', ['style']],
              ['font', ['bold', 'underline', 'clear']],
              ['color', ['color']],
              ['para', ['ul', 'ol', 'paragraph']]
            ]
          });
      });

      $('#location_site_attributes_company_info').summernote('code', this.data.site.company_info);
      $('#location_site_attributes_qualifying_leads').summernote('code', this.data.site.qualifying_leads);

      this.querySelector('.cancel').addEventListener('click', function() {
        this.resetData();
      }.bind(this))
      this.querySelector('.save').addEventListener('click', function() {
        this.save();
      }.bind(this))

      let ten_dlc_brand = new TenDLCBrandModal(this.data.site);
      this.querySelector('#ten-dlc-brand-container').appendChild(ten_dlc_brand)

      // let recipient = new TextNotificationRecipient;
      // this.querySelector('#text-notification-recipients-container').appendChild(recipient)
  }

  show() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }

  // Hide/show text notification recipients
  // toggleTNR() {
  //   if(this.querySelector('#MC-offline-notifications').checked) {
  //     this.querySelector('#text-notification-recipients').classList.add('hidden');
  //   } else {
  //     this.querySelector('#text-notification-recipients').classList.remove('hidden');
  //   }
  // }

  getHours() {
    let hours_array = [];
    this.querySelectorAll('location-hours').forEach(elem => {
      hours_array.push(elem.getHoursObject());
    })
    if(this.deletedHours.length > 0) {
      this.deletedHours.forEach(obj => {
        hours_array.push(obj);
      })
    }
    return hours_array;
  }

  addDeletedHours(data) {
    // Post data for existing hours being deleted
    this.deletedHours.push(data);
  }

  buttonVisibility() {
    if(this.querySelectorAll('location-hours').length >= 7) {
      this.querySelector('#location-hours-button').classList.add('hidden');
    } else {
      this.querySelector('#location-hours-button').classList.remove('hidden');
    }
  }

  async resetData() {
    if(await confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/domains';
    }
  }

  validate() {
    let isValid = true;
    let errors = "";
    let new_emails = this.querySelector('.NLE-recipients').value.replace(/\s/g,'').split(',');
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })

    new_emails.forEach(address => {
      if(this.querySelector('#NLE-notifications').checked && !Common.validateCommaSeperatedEmail(address)) {
        errors = `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Invalid email address included.
                  </div>`;
        this.querySelector('.NLE-recipients').classList.add('error');
        isValid = false;
      }
    })

    if(this.querySelector('#NLE-notifications').checked && !this.querySelector('.NLE-recipients').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide recipient emails when enabled.
                  </div>`;
      this.querySelector('.NLE-recipients').classList.add('error')
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid;
  }

  async save() {
    if(this.validate()) {
      this.querySelector('.save').setAttribute("disabled", true);
      let data = {
        company_info: this.querySelector('#location_site_attributes_company_info').value,
        qualifying_leads: this.querySelector('#location_site_attributes_qualifying_leads').value,
        sites_chat_hours: this.getHours(),
        chat_notification: this.querySelector('#NLE-notifications').checked ? 1 : 0,
        chat_notification_recipients: this.querySelector('.NLE-recipients').value.replace(/\s/g,'')
      };
      let res = await fetch(`/admin/domains/${this.domain_id}/message_center`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('Message Center settings updated', 'success');
        this.data = response.data;
        this.data_binder.fetchData();
      } else {
        Common.notify(`Unable to update Message Center settings. ${response.error ? response.error : ""}`, 'error');
      }
      this.querySelector('.save').removeAttribute("disabled");
    }
  }
}

customElements.define('message-center-settings', MessageCenterSettings)

class CampaignNotifications extends HTMLElement {
  constructor(data, domain_id) {
    super();
    this.data = data;
    this.domain_id = domain_id;
  }

  connectedCallback() {
    // Add comma/space for display only
    let missed_call_emails = this.data.site.notification_type_emails.filter((notification)=>notification.notification_type_id==CampaignNotifications.MISSED_CALL_TYPE)
    let missed_call_recipients = missed_call_emails[0] ? missed_call_emails[0].recipients.split(',').join(', ') : '';

    let voicemail_emails = this.data.site.notification_type_emails.filter((notification)=>notification.notification_type_id==CampaignNotifications.VOICEMAIL_TYPE)
    let voicemail_recipients = voicemail_emails[0] ? voicemail_emails[0].recipients.split(',').join(', ') : '';
    this.innerHTML = 
      `
      <div class="location-settings-main col-md-12">
        <h3>Notifications</h3>
        <p>Manage the notifications for Campaigns and Digital Campaigns</p>
      </div>
      <div id="campaign-notifications-main" class="row location-settings-main col-md-12 col-lg-8">
        <div class="errors"></div>
        <div class="col-sm-12 no-gutters location-settings-switch-div location-site-attributes">
          <div class="col-sm-6 no-gutters">
            <label>Missed Calls</label>
            <br>
            <span>Calls that are not answered and are a minimum of 2 rings</span>
          </div>
          <label class="col-sm-6 no-gutters switch">
            <input type="checkbox" class="form-control switch" id="MC-offline-notifications" ${missed_call_emails[0] != null && missed_call_emails[0].enabled == 1 ? 'checked' : ''}>
            <span data-cy="MC-offline-notifications-switch"></span>
          </label>
        </div>
        <div class="col-sm-12 no-gutters location-site-attributes">
          <label>E-mail Notification Recipients</label>
          <p>You can send notifications to e-mail addresses of your choice</p>
          <p>Please separate e-mail addresses by using a comma</p>
          <textarea id="campaign-notifications-recipients" class="form-control" rows=4 placeholder="e.g.: one@example.com, two@example.com">${missed_call_recipients}</textarea>
        </div>
        <div class="col-sm-12 no-gutters location-settings-switch-div location-site-attributes">
          <div class="col-sm-6 no-gutters">
            <label>Voicemails</label>
            <br>
            <span>Calls that ended up going to voicemail.</span>
          </div>
          <label class="col-sm-6 no-gutters switch">
            <input type="checkbox" class="form-control switch" id="voicemail-notifications" ${voicemail_emails[0] != null && voicemail_emails[0].enabled == 1 ? 'checked' : ''}>
            <span data-cy="voicemail-notifications"></span>
          </label>
        </div>
        <div class="col-sm-12 no-gutters location-site-attributes">
          <label>E-mail Notification Recipients</label>
          <p>You can send notifications to e-mail addresses of your choice</p>
          <p>Please separate e-mail addresses by using a comma</p>
          <textarea id="voicemail-notifications-recipients" class="form-control" rows=4 placeholder="e.g.: one@example.com, two@example.com">${voicemail_recipients}</textarea>
        </div>

        <div class="col-md-12 location-settings-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-campaign-notifications-settings">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-hidden location-settings-main">
        ${LocationDocumentation.campaign_notifications}
      </div>
      `;

    this.querySelector('.cancel').addEventListener('click', function() {
      this.resetData();
    }.bind(this))
    this.querySelector('.save').addEventListener('click', function() {
      this.save();
    }.bind(this))
  }

  show() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }

  async resetData() {
    if(await confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/domains';
    }
  }

  validate() {
    let isValid = true;
    let errors = "";
    let missed_call_emails = this.querySelector('#campaign-notifications-recipients').value.replace(/\s/g,'').split(',');
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })

    missed_call_emails.forEach(address => {
      if(this.querySelector('#MC-offline-notifications').checked && !Common.validateCommaSeperatedEmail(address)) {
        errors = `<div class="alert alert-danger alert-dismissible" role="alert">
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <strong>Warning!</strong> Invalid email address included.
                </div>`;
        this.querySelector('#campaign-notifications-recipients').classList.add('error');
        isValid = false;
      }
    })
    

    if(this.querySelector('#MC-offline-notifications').checked && !this.querySelector('#campaign-notifications-recipients').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide recipient emails when enabled.
                  </div>`;
      this.querySelector('#campaign-notifications-recipients').classList.add('error')
      isValid = false;
    }

    let voicemail_emails = this.querySelector('#voicemail-notifications-recipients').value.replace(/\s/g,'').split(',');
    voicemail_emails.forEach(address => {
      if(this.querySelector('#voicemail-notifications').checked && !Common.validateCommaSeperatedEmail(address)) {
        errors = `<div class="alert alert-danger alert-dismissible" role="alert">
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <strong>Warning!</strong> Invalid email address included.
                </div>`;
        this.querySelector('#voicemail-notifications-recipients').classList.add('error');
        isValid = false;
      }
    })
    

    if(this.querySelector('#voicemail-notifications').checked && !this.querySelector('#voicemail-notifications-recipients').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide recipient emails when enabled.
                  </div>`;
      this.querySelector('#voicemail-notifications-recipients').classList.add('error')
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid;
  }

  async save() {
    if(this.validate()) {
      this.querySelector('.save').setAttribute("disabled", true);
      let missed_call_emails = this.data.site.notification_type_emails.filter((notification)=>notification.notification_type_id==CampaignNotifications.MISSED_CALL_TYPE);
      let voicemail_emails = this.data.site.notification_type_emails.filter((notification)=>notification.notification_type_id==CampaignNotifications.VOICEMAIL_TYPE);

      let notifications = [{
        notification_email_id: missed_call_emails.length > 0 ? missed_call_emails[0].notification_email_id : null,
        notification_type_id: CampaignNotifications.MISSED_CALL_TYPE,
        enabled: this.querySelector('#MC-offline-notifications').checked ? 1 : 0,
        recipients: this.querySelector('#campaign-notifications-recipients').value.replace(/\s/g,'')
      },
      {
        notification_email_id: voicemail_emails.length > 0 ? voicemail_emails[0].notification_email_id : null,
        notification_type_id: CampaignNotifications.VOICEMAIL_TYPE,
        enabled: this.querySelector('#voicemail-notifications').checked ? 1 : 0,
        recipients: this.querySelector('#voicemail-notifications-recipients').value.replace(/\s/g,'')
      }];

      let res = await fetch(`/admin/domains/${this.domain_id}/campaign_notifications`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(notifications)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('Campaign notifications settings updated', 'success');
      } else {
        Common.notify(`Unable to update Campaign notifications settings. ${response.error ? response.error : ""}`, 'error');
      }
      this.querySelector('.save').removeAttribute("disabled");
    }
  }
}

CampaignNotifications.MISSED_CALL_TYPE = 1;
CampaignNotifications.VOICEMAIL_TYPE = 2;

customElements.define('campaign-notifications', CampaignNotifications)

class DealSaverSetup extends HTMLElement {
  constructor(data, domain_id, current_user_is_account_admin) {
    super();
    this.data = data;
    this.domain_id = domain_id;
    this.current_user_is_account_admin = current_user_is_account_admin;
  }

  connectedCallback() {
    this.innerHTML = 
      `
      <style>
        dealsaver-setup textarea .form-control {
          height: 68px;
        }

        .processing_queue_attributes .table_container {
          border: 1px solid #aaa;
          border-radius:6px;
        }

        .processing_queue_attributes .table_container .table{
          margin-bottom:inherit;
        }

        #selected-queue-data {
          margin-top:10px;
        }

        #leadscore-container {
          margin: 12px 0px;
        }


      </style>
      <div class="location-settings-main col-md-12">
        <h3>Call Processing</h3>
        <p></p>
      </div>

      <div class="row location-settings-main col-md-12 col-lg-12">
        <h3>Call Processing Queue Setup</h3>
        <div id="processing-queue-container" class="well">
            <h4 class="hide" id="current-processing-queue"></h4>
            <select id="processing-queue-menu" class="form-control"></select>
            <div class="row" id='selected-queue-data'></div>
          </div>
        </div>
      </div>

      <div id="dealsaver-setup-main" class="row location-settings-main col-md-12 col-lg-8">
        <div class="errors"></div>
        <div id="leadscore-container" class="col-sm-12 no-gutters">
          <h3>LeadScore Setup</h3>
          <div id="leadscore-container">
            <label>LeadScore Minimum Duration</label>
            <select id="leadscore-min-duration" class="form-control"></select>
          </div>
        </div>
        <div id="dealsaver-container">
          <h3>DealSaver Setup</h3>
        
        </div>
        <div class="col-md-12 location-settings-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-dealsaver-setup">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-hidden location-settings-main">
        ${this.data.prospect_call_types.length > 0 ? LocationDocumentation.call_processing : ""}
      </div>
      `;

    this.querySelector('#processing-queue-menu').addEventListener('change', function(e) {
      const v = e.currentTarget.value
      this.lookupProcessingQueueAttributes(v)
    }.bind(this))

    this.render_prospect_call_types(this.data.prospect_call_types, this.data.all_call_types)
    this.leadscoreDuration();
    this.populateProcessingQueueMenu();


    this.querySelector('.cancel').addEventListener('click', function() {
      this.resetData();
    }.bind(this))
    this.querySelector('.save').addEventListener('click', function() {
      this.save();
    }.bind(this))
  }

  render_prospect_call_types(prospect_call_types, all_call_types) {
    // clean up any existing forms
    this.querySelectorAll('dealsaver-form').forEach(elem => {
      elem.remove();
    })
    this.querySelectorAll('leadscore-form').forEach(elem => {
      elem.remove();
    })

    // Displays DealSavers based on industry
    if(prospect_call_types.length == 0) {
      this.querySelector('#dealsaver-container').classList.add('hidden');
    } else {
      this.querySelector('#dealsaver-container').classList.remove('hidden');
    }
    
    // Populate DealSaver components
    prospect_call_types.forEach(type => {
      let type_data = type;
      
      let dealsaver_data = this.data.domain.location_dealsavers.filter(dealsaver => dealsaver.call_type_id == type.call_type_id);
      dealsaver_data = dealsaver_data ? dealsaver_data[0] : null;
      let dealsaver_actions_data = this.data.domain.call_processing_actions.filter(call_processing_action => call_processing_action.call_type_id == type.call_type_id && call_processing_action.trigger_on_dealsaver == 1)
      let dealsaver_form = new DealSaverForm(dealsaver_data, dealsaver_actions_data, type_data);
      this.querySelector('#dealsaver-container').appendChild(dealsaver_form);
    });

    all_call_types.forEach(type => {
      let type_data = type;
      
      let leadscore_actions_data = this.data.domain.call_processing_actions.filter(call_processing_action => call_processing_action.call_type_id == type.call_type_id && call_processing_action.trigger_on_leadscore == 1)
      let leadscore_form = new LeadScoreForm(leadscore_actions_data, type_data);
      this.querySelector('#leadscore-container').appendChild(leadscore_form);
    });
  }
  
  async lookupProcessingQueueAttributes(queue_id) {
    if (parseInt(queue_id) === 0) {
      // clear the associated data 
      this.querySelector('#selected-queue-data').innerHTML = ''
      // clear the associated dealsaver 
      this.querySelector('#dealsaver-container').classList.add('hidden');
      return
    }

    const loading_html = `<div style="text-align:center"><span style>Loading...</span></div>`
    this.querySelector('#selected-queue-data').innerHTML = loading_html
    let res = await fetch(`/admin/processing_queue_type/${queue_id}/attributes`);
    let json = await res.json();
    const departments_html = this.render_departments(json.attributes.departments)
    const call_alerts_html = this.render_call_alerts(json.attributes.call_alerts)
    const call_types_html = this.render_call_types(json.attributes.call_types)
    const new_html =  `${departments_html}${call_alerts_html}${call_types_html}`
    this.querySelector('#selected-queue-data').innerHTML = new_html

    // generate the new dealsaver code here
    this.render_prospect_call_types(json.attributes.prospect_call_types, json.attributes.all_call_types)
  }
  
  render_departments(json) {
    let html = `<div class='processing_queue_attributes col-md-2' >`
    html += '<div class="table_container"><table class="table"><thead><tr><th>Departments</th></thead><tbody>'

    if (json.length === 0) {
      html += `<tr><td>No department data.</td></tr>`
    }
    else {
      
      for(let i in json) {
        const temp = json[i];
        html += `<tr><td>${temp}</ld></tr>`
      }
    }

    html += '</tbody></table></div></div>'
    return html
  }

  render_call_alerts(json) {
    let html = `<div class='processing_queue_attributes col-md-4' >`
    html += '<div class="table_container"><table class="table"><thead><tr><th>Call Alerts</th></thead><tbody>'

    if (json.length === 0) {
      html += `<tr><td>No call alert data.</td></tr>`
    }
    else {
      
      for(let i in json) {
        const temp = json[i];
        html += `<tr><td>${temp}</ld></tr>`
      }
    }

    html += '</tbody></table></div></div>'
    return html
  }

  render_call_types(json) {
    let html = `<div class='processing_queue_attributes col-md-6' >`
    html += `
      <div class="table_container">
        <table class="table">
          <thead>
            <tr>
              <th>Call Type ID</th>
              <th>Call Types</th>
              <th>Prospect?</th>
              <th>Call Status</th>
            </tr>
          </thead>
          <tbody>`

    if (json.length === 0) {
      html += `<tr><td>No call type data.</td></tr>`
    }
    else {
      for(let i in json) {
        const temp = json[i];
        html += `
          <tr>
            <td>${temp.id}</td>
            <td>${temp.call_type_text}</td>
            <td>${temp.is_prospect ? 'X' : ''}</td>`

        //html += `<td>Call Status</td>`
        html += `<td>`
        for(let j in temp.call_stati) {
          const status = temp.call_stati[j]
          html += `${status} <br\>`
        }
        html += `</td></tr>`
      }
    }

    html += '</tbody></table></div></div>'
    return html
  }

  show() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }

  reload(data) {
    this.data = data;
    this.connectedCallback();
  }

  leadscoreDuration() {
    let options = [];
    for (let i = 10; i <= 120; i += 5) {
      let minutes = Math.floor(i / 60);
      let seconds = i % 60;
      let min_str = (minutes > 0) ? `${minutes} minute${minutes > 1 ? "s" : ""}`: "";
      let sec_str = (seconds > 0) ? `${seconds} seconds` : "";
      options.push(`<option value="${i}" ${i == this.data.domain.leadscore_min_duration ? 'selected' : ''}>${min_str} ${sec_str}</option>`);
    }
    this.querySelector('#leadscore-min-duration').innerHTML = options.join('');
  }

  async populateProcessingQueueMenu() {
    let res = await fetch(`/admin/processing_queue_type/${this.domain_id}/types`);
    let json = await res.json();
    let options = [];
    let selected_id = json.selected_id
    // if a queue has been selected, we do not allow them to change it.
    // Here we check to see if no queue has been selected or if the No queue option has been selected.
    // If either is true, we want to let the user select a processing queue
    //
    // AT-2144 account admins cannot change this value.
    // if an account admin is viewing this, they can view the selected queue data.
    options.push(`<option value="0" ${0 == selected_id ? 'selected' : ''}}>No Call Processing Queue</option>`);

    for(let i in json.queue_types) {
      const temp = json.queue_types[i]
      options.push(`<option value="${temp.processing_queue_type_id}" ${temp.processing_queue_type_id == selected_id ? 'selected' : ''}>${temp.name}</option>`);
    }
    
    this.querySelector('#processing-queue-menu').innerHTML = options.join('');

    if (this.current_user_is_account_admin === false && (selected_id === null || selected_id === 0)) {
      // get data for the current selected queue
      const v = this.querySelector('#processing-queue-menu').value
      this.lookupProcessingQueueAttributes(v)
    }
    else {
      // just show the selected queue name
      const selectedQueue = json.queue_types.find(x => x.processing_queue_type_id === selected_id)
      if (selectedQueue) {
        document.querySelector('#current-processing-queue').textContent = `Queue: ${selectedQueue.name}`
        document.querySelector('#current-processing-queue').classList.remove("hide")
        document.querySelector('#processing-queue-menu').classList.add("hide")

        // get data for the current selected queue
        this.lookupProcessingQueueAttributes(selected_id)
      }
      else if (this.current_user_is_account_admin){
        // hide everything if no queue has been selected yet and an
        // account admin is viewing this.
        this.querySelector('#processing-queue-container').classList.add("hide")
      }
    }
  }
  
  async resetData() {
    if(await confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/domains';
    }
  }

  validate() {
    let isValid = true;
    let errors = []
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })

    this.querySelectorAll('dealsaver-form').forEach(elem => {
      if(elem.validate().includes('empty')) {
        errors.push(`<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please provide recipient emails when enabled.
                    </div>`);
        isValid = false;
      }
      if(elem.validate().includes('email')) {
        errors.push(`<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Invalid email address included.
                    </div>`);
        isValid = false;
      }
      if(elem.validate().includes('duplicate_integrations')) {
        errors.push(`<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> You have duplicate Integrations being used.
                    </div>`);
        isValid = false;
      }
    })

    this.querySelectorAll('leadscore-form').forEach(elem => {
      if(elem.validate().includes('empty')) {
        errors.push(`<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Please provide recipient emails when enabled.
                    </div>`);
        isValid = false;
      }
      if(elem.validate().includes('email')) {
        errors.push(`<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> Invalid email address included.
                    </div>`);
        isValid = false;
      }
      if(elem.validate().includes('duplicate_integrations')) {
        errors.push(`<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> You have duplicate Integrations being used.
                    </div>`);
        isValid = false;
      }
    })

    
    
    this.querySelector('.errors').innerHTML = [...new Set(errors)];
    return isValid;
  }

  async save() {
    let data = {
      leadscore_min_duration: this.querySelector('#leadscore-min-duration').value,
      processing_queue_menu: this.querySelector('#processing-queue-menu').value
    };
    if(this.validate()) {
      this.querySelector('.save').setAttribute("disabled", true);
      let location_dealsavers = [];
      this.querySelectorAll('dealsaver-form').forEach(elem => {
        location_dealsavers.push(elem.getDealsavers());
      })
      data.location_dealsavers = location_dealsavers;

      let location_leadscores = [];
      this.querySelectorAll('leadscore-form').forEach(elem => {
        location_leadscores.push(elem.getData());
      })
      data.location_leadscores = location_leadscores;
      let res = await fetch(`/admin/domains/${this.domain_id}/dealsaver`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('Dealsaver settings updated', 'success');
        // rebuild the deal saver data again now that we have records with ids.
        // This is needed so if we save again we do not generate duplicate records.
        this.data = response.data
        this.render_prospect_call_types(this.data.prospect_call_types, this.data.all_call_types)
        document.querySelector('#processing-queue-menu').setAttribute('disabled','true')
      } else {
        Common.notify(`Unable to update Dealsaver settings. ${response.error ? response.error : ""}`, 'error');
      }
      this.querySelector('.save').removeAttribute("disabled");
    }
  }
}

customElements.define('dealsaver-setup', DealSaverSetup)

class CompanyIntegrations extends HTMLElement {
  constructor(data, domain_id) {
    super();
    this.data = data;
    this.domain_id = domain_id;
  }

  connectedCallback() {
    this.innerHTML = 
      `
      <div class="location-settings-main col-md-12">
        <h3>Company Integrations</h3>
      </div>
      <div id="" class="row location-settings-main col-md-12 col-lg-8 no-gutters">
        <div class="errors"></div>
        <div>
          <h4><b>Location Profile</b></h4>
          <label>Account ID</label>
          <input type="text" id="integration-account-id" class="form-control location-site-attributes" data-cy="integration-account-id" value="${this.data.domain.cs_account_id ? this.data.domain.cs_account_id : ''}" maxlength="100">
          <label>Location ID</label>
          <input type="text" id="integration-location-id" class="form-control location-site-attributes" data-cy="integration-location-id" value="${this.data.domain.cs_location_id ? this.data.domain.cs_location_id : ''}" maxlength="100">
        </div>
        <div class="location-site-attributes">
          <h4><b>Connections Profile</b></h4>
          <label>Dealer ID</label>
          <input type="number" id="integration-dealer-id" class="form-control" data-cy="integration-dealer-id" value="${this.data.domain.connections_company_id ? this.data.domain.connections_company_id : ''}" maxlength="9" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
        </div>
        <div class="col-md-12 no-gutters location-settings-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-dealsaver-setup">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-hidden location-settings-main">
        <!--${LocationDocumentation.company_integrations}-->
      </div>
      `;

    this.querySelector('.cancel').addEventListener('click', function() {
      this.resetData();
    }.bind(this))
    this.querySelector('.save').addEventListener('click', function() {
      this.save();
    }.bind(this))
  }
  show() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }

  async resetData() {
    if(await confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/domains';
    }
  }

  validate() {
    return true
  }

  async save() {
    let data = {
      cs_account_id: this.querySelector('#integration-account-id').value,
      cs_location_id: this.querySelector('#integration-location-id').value,
      connections_company_id: this.querySelector('#integration-dealer-id').value
    }
    if(this.validate()) {
      this.querySelector('.save').setAttribute("disabled", true);
      let res = await fetch(`/admin/domains/${this.domain_id}/company_integrations`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('Company Integrations settings updated', 'success');
      } else {
        Common.notify(`Unable to update Company Integrations settings. ${response.error ? response.error : ""}`, 'error');
      }
      this.querySelector('.save').removeAttribute("disabled");
    }
  }
}

customElements.define('company-integrations', CompanyIntegrations)

class CallshieldSettings extends HTMLElement {
  constructor(data, domain_id) {
    super();
    this.data = data;
    this.domain_id = domain_id;
  }
  connectedCallback() {
    this.innerHTML =
      `
      <div class="location-settings-main col-md-12">
        <h3>CallShield</h3>
      </div>
      <div id="" class="row location-settings-main col-md-12 col-lg-8">
        <div class="errors"></div>
        <div>
          <label>Custom CallShield Prompt</label>
        </div>
        <div class="col-sm-12 no-gutters audio-select-row location-site-attributes">
          <select is=audio-select target_audio_type=5 class="form-control" id="callshield_prompt" data-cy="" default_option_text="Default Audio" data-selected="${this.data.site.callshield_audio_id}"></select>
          <button class="btn btn-secondary ct_manage_audio" data-audio-type-id="5">Manage</button>
        </div>

        <div class="col-sm-12 no-gutters location-settings-switch-div location-site-attributes">
          <div class="col-sm-4 no-gutters ">
            <label>Always Enable CallShield</label>
            <br>
            <span></span>
          </div>
          <label class="col-sm-8 no-gutters switch">
            <input type="checkbox" class="form-control switch" id="enable_callshield_switch" ${this.data.site.callshield_force_prompt == 1 ? 'checked' : ''}>
            <span data-cy="outbound-call-analysis-switch"></span>
          </label>
        </div>
        <div class="col-md-12 no-gutters location-settings-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-dealsaver-setup">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-hidden location-settings-main">
        ${LocationDocumentation.callshield}
      </div>
      `;

    this.querySelector('.cancel').addEventListener('click', function() {
      this.resetData();
    }.bind(this))
    this.querySelector('.save').addEventListener('click', function() {
      this.save();
    }.bind(this))
  }
  show() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }

  async resetData() {
    if(await confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/domains';
    }
  }

  validate() {
    return true
  }

  async save() {
    let data = {
      callshield_audio_id : this.querySelector('#callshield_prompt').value,
      callshield_force_prompt: this.querySelector('#enable_callshield_switch').checked ? 1 : 0
    }
    if(this.validate()) {
      this.querySelector('.save').setAttribute("disabled", true);
      let res = await fetch(`/admin/domains/${this.domain_id}/callshield_settings`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('CallShield settings updated', 'success');
      } else {
        Common.notify(`Unable to update CallShield settings. ${response.error ? response.error : ""}`, 'error');
      }
      this.querySelector('.save').removeAttribute("disabled");
    }
  }
}

customElements.define('callshield-settings', CallshieldSettings)